var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(233 487)",
    style: {
      fill: "#3b5175",
      stroke: "#707070"
    },
    d: "M0 0h24v24H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".d{fill:#3b5175}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233 -487)",
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z",
    transform: "translate(233 487)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m255.7 498.7-4.9-4.9a.95.95 0 0 0-1.4 0l-9.1 9.1a1 1 0 0 0-.3.7v-.1h-5a1 1 0 0 0 0 2h5v3a1 1 0 0 0 1 1h4.9a1 1 0 0 0 .7-.3l9.1-9.1a.95.95 0 0 0 0-1.4Zm-10.25 8.8H242v-3.45l5.2-5.2 3.45 3.45Zm6.6-6.6-3.45-3.45 1.5-1.55 3.5 3.5ZM239 496.5a1 1 0 0 0-2 0v3h2ZM250.1 491.5a1 1 0 0 1 .7.3l.2.2v-2.5a1.05 1.05 0 0 0-1-1 1 1 0 0 0-1 1v2.7l.4-.4a1 1 0 0 1 .7-.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M243 498.2v-4.7a1.05 1.05 0 0 0-1-1 1 1 0 0 0-1 1v6h.7ZM247 491a1.05 1.05 0 0 0-1-1 1 1 0 0 0-1 1v5.2l2-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_icon.aaf9ce0ed577f826feb32de03829ccff.svg";
export { ForwardRef as ReactComponent };